// axios-token.interceptor.ts
import axios, { AxiosRequestConfig } from 'axios';
import { AuthService } from './authentication.service';

let refreshInFlight: Promise<string> | null = null;

export function setupAxiosTokenInterceptor(auth: AuthService) {
  axios.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
      // Prevent multiple parallel renewals
      if (!refreshInFlight) {
        refreshInFlight = auth.renewTokens()
          .then((value) => {
            refreshInFlight = null;
            return value;
          }, (err) => {
            refreshInFlight = null;
            throw err;
          });
      }

      const token = await refreshInFlight;
      if (token) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${token}`;
      }

      return config;
    },
    error => Promise.reject(error)
  );
}
